var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1833_4596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1833_4596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9692 32C12.1129 32 8.72401 30.8059 5.80247 28.4177C2.88092 26.0295 1.04443 22.9893 0.292993 19.2973C0.213274 18.9388 0.281344 18.6187 0.497204 18.3368C0.713063 18.055 1.00022 17.8915 1.35868 17.8463C1.71713 17.8008 2.03292 17.886 2.30605 18.1019C2.57917 18.3178 2.76429 18.6049 2.86141 18.9634C3.5438 22.0188 5.10113 24.5345 7.53341 26.5103C9.96598 28.4859 12.7779 29.4737 15.9692 29.4737C19.7306 29.4737 22.9166 28.1684 25.5271 25.5579C28.1376 22.9474 29.4429 19.7614 29.4429 16C29.4429 12.2386 28.1376 9.05263 25.5271 6.44211C22.9166 3.83158 19.7306 2.52632 15.9692 2.52632C13.4364 2.52632 11.106 3.17684 8.97805 4.47789C6.85005 5.77867 5.20962 7.56267 4.05678 9.8299H7.7751C8.13271 9.8299 8.43264 9.95102 8.67489 10.1933C8.91685 10.4355 9.03784 10.7357 9.03784 11.0939C9.03784 11.4518 8.91685 11.7517 8.67489 11.9937C8.43264 12.2354 8.13271 12.3562 7.7751 12.3562H2.5751C2.01454 12.3562 1.5685 12.1295 1.23699 11.6762C0.905765 11.2226 0.838397 10.7422 1.03489 10.2349C2.20289 7.18176 4.14352 4.71256 6.85678 2.82737C9.56976 0.942457 12.6072 0 15.9692 0C18.1825 0 20.2625 0.419929 22.2092 1.25979C24.1559 2.09965 25.8492 3.23944 27.2892 4.67916C28.7292 6.11888 29.8691 7.81193 30.709 9.75832C31.5491 11.7047 31.9692 13.7843 31.9692 15.9971C31.9692 18.2101 31.5491 20.2902 30.709 22.2375C29.8691 24.1847 28.7292 25.8785 27.2892 27.3187C25.8492 28.759 24.1559 29.8994 22.2092 30.7398C20.2625 31.5799 18.1825 32 15.9692 32ZM17.2324 15.4884L21.4429 19.7149C21.6762 19.9446 21.7928 20.2368 21.7928 20.5916C21.7928 20.9464 21.6762 21.2431 21.4429 21.4817C21.2096 21.7203 20.9138 21.8369 20.5553 21.8316C20.1969 21.8262 19.9011 21.7069 19.6681 21.4737L15.1675 16.9731C15.0067 16.8122 14.8896 16.6389 14.8164 16.4531C14.7428 16.2672 14.706 16.0752 14.706 15.8771V9.45768C14.706 9.09979 14.8272 8.79972 15.0694 8.55747C15.3117 8.31551 15.6117 8.19453 15.9696 8.19453C16.3278 8.19453 16.6277 8.31551 16.8694 8.55747C17.1114 8.79972 17.2324 9.09979 17.2324 9.45768V15.4884Z",
    fill: "var(--ion-color-primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataOrderIcon);
export default __webpack_public_path__ + "static/media/no-data-order-icon.090555afea3038739a6d4295711d54bf.svg";
export { ForwardRef as ReactComponent };